export const selling_points = [
  {
    "type": "Банкомат",
    "adress": "Тверь, наб, Афанасия Никитина, 22",
    "coords": [
      56.865348,
      35.914834
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Калинина, 19",
    "coords": [
      56.854719,
      35.86787
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Строителей, 4",
    "coords": [
      56.841596,
      35.846705
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Советская, 13",
    "coords": [
      56.859837,
      35.913019
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Победы, 14",
    "coords": [
      56.845628,
      35.914259
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Волоколамский, 24",
    "coords": [
      56.836692,
      35.907845
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Софьи Перовской, 6",
    "coords": [
      56.860314,
      35.888558
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Скворцова-Степанова, 7",
    "coords": [
      56.871158,
      35.887264
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, наб, Реки Лазури, 1а",
    "coords": [
      56.849979,
      35.921616
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Калинина, 19",
    "coords": [
      56.854719,
      35.86787
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Горького, 21",
    "coords": [
      56.866558,
      35.909543
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Ленина, 5",
    "coords": [
      56.848517,
      35.828568
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ш, Петербургское, 54/2",
    "coords": [
      56.874066,
      35.852491
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, б-р, Молодежный, 2",
    "coords": [
      56.883042,
      35.84039
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 113",
    "coords": [
      56.809788,
      35.875937
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, б-р, Молодежный, 2",
    "coords": [
      56.883042,
      35.84039
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Ленина, 5",
    "coords": [
      56.848517,
      35.828568
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Салтыкова-Щедрина, 20",
    "coords": [
      56.855241,
      35.921005
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Чайковского, 28",
    "coords": [
      56.845155,
      35.904826
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ш, Петербургское, 54/2",
    "coords": [
      56.874066,
      35.852491
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ш, Петербургское, 54/2",
    "coords": [
      56.874066,
      35.852491
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, п, Химинститута, 2",
    "coords": [
      56.800074,
      36.03148
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пл, Терешковой, 47/27",
    "coords": [
      56.839213,
      35.931623
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Горького, 136/6",
    "coords": [
      56.87014,
      35.888019
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Можайского, 71",
    "coords": [
      56.819331,
      35.904126
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Маршала Конева, 71",
    "coords": [
      56.845116,
      35.831686
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, 15 Лет Октября, 7",
    "coords": [
      56.844353,
      35.930366
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Победы, 27",
    "coords": [
      56.84326,
      35.922128
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Кольцевая, 66",
    "coords": [
      56.88848,
      35.902428
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Ленина, 30",
    "coords": [
      56.851397,
      35.843274
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Петербургское, 45Б",
    "coords": [
      56.872752,
      35.852473
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Вагжанова, 19",
    "coords": [
      56.851289,
      35.937813
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Горького, 86/3",
    "coords": [
      56.868162,
      35.899455
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Победы, 27",
    "coords": [
      56.84326,
      35.922128
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 28",
    "coords": [
      56.828847,
      35.895673
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Чайковского, 7",
    "coords": [
      56.848857,
      35.905716
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Эрнста Тельмана, 18/22",
    "coords": [
      56.891371,
      35.8813
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Можайского, 71",
    "coords": [
      56.819331,
      35.904126
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Октябрьский, 99",
    "coords": [
      56.817454,
      35.887444
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Московское, 157",
    "coords": [
      56.795973,
      36.051935
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, п, Химинститута, 2",
    "coords": [
      56.800074,
      36.03148
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Склизкова, 94",
    "coords": [
      56.833634,
      35.935944
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Ленина, 5",
    "coords": [
      56.848517,
      35.828568
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Петербургское, 45",
    "coords": [
      56.873411,
      35.851368
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Хромова, 17 к.1",
    "coords": [
      56.880415,
      35.845951
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Комсомольский, 1",
    "coords": [
      56.865968,
      35.911088
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Победы, 71",
    "coords": [
      56.834934,
      35.943472
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пл, Терешковой, 47/27",
    "coords": [
      56.839213,
      35.931623
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Московское, 16",
    "coords": [
      56.844678,
      35.948269
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Советская, 4",
    "coords": [
      56.860649,
      35.899562
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Горького, 21",
    "coords": [
      56.866558,
      35.909543
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пл, Терешковой, 47/27",
    "coords": [
      56.839213,
      35.931623
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Хрустальная, 32/67",
    "coords": [
      56.889946,
      35.904431
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, б-р, Цанова, 8",
    "coords": [
      56.830014,
      35.917547
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Петербургское, 45Б",
    "coords": [
      56.872752,
      35.852473
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Кривичская, 12",
    "coords": [
      56.857736,
      35.793247
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Орджоникидзе, 48",
    "coords": [
      56.833664,
      35.922919
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, тер, Технопарк ДКС, 5",
    "coords": [
      56.450091,
      33.362495
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, п, Химинститута, 2",
    "coords": [
      56.800074,
      36.03148
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Петербургское, 36",
    "coords": [
      56.873421,
      35.858761
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, б-р, Молодежный, 2",
    "coords": [
      56.883042,
      35.84039
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Индустриальная, 13",
    "coords": [
      56.846568,
      35.961393
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Ленина, 5",
    "coords": [
      56.848517,
      35.828568
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Дружинная, 5",
    "coords": [
      56.827572,
      35.861483
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 26",
    "coords": [
      56.829369,
      35.89711
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Димитрова, 21",
    "coords": [
      56.905927,
      35.901027
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Горького, 136/6",
    "coords": [
      56.87014,
      35.888019
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, , торгово-промышленная зона Боровлево, 2",
    "coords": [
      56.795209,
      35.948035
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Победы, 14",
    "coords": [
      56.845628,
      35.914259
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Горького, 86/3",
    "coords": [
      56.868162,
      35.899455
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Луначарского, 30А",
    "coords": [
      56.881261,
      35.855734
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Ленина, 5",
    "coords": [
      56.848517,
      35.828568
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Скворцова-Степанова, 7",
    "coords": [
      56.871158,
      35.887264
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Волоколамский, 24",
    "coords": [
      56.836692,
      35.907845
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Ротмистрова, 31",
    "coords": [
      56.847208,
      35.927078
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, б-р, Молодежный, 2",
    "coords": [
      56.883042,
      35.84039
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Хрустальная, 32/67",
    "coords": [
      56.889946,
      35.904431
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Ленина, 5",
    "coords": [
      56.848517,
      35.828568
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Салтыкова-Щедрина, 26",
    "coords": [
      56.855797,
      35.921742
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Можайского, 71",
    "coords": [
      56.819331,
      35.904126
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Волоколамский, 24",
    "coords": [
      56.836692,
      35.907845
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Волоколамский, 24",
    "coords": [
      56.836692,
      35.907845
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ш, Петербургское, 54/2",
    "coords": [
      56.874066,
      35.852491
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Тверской, 10",
    "coords": [
      56.857977,
      35.908752
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 99",
    "coords": [
      56.817454,
      35.887444
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, б-р, Молодежный, 2",
    "coords": [
      56.883042,
      35.84039
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Дарвина, 12",
    "coords": [
      56.850038,
      35.894487
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, б-р, Цанова, 1б",
    "coords": [
      56.835131,
      35.906991
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Петербургское, 115 к. 3",
    "coords": [
      56.872816,
      35.823439
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Можайского, 71",
    "coords": [
      56.819331,
      35.904126
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Петербургское, 45",
    "coords": [
      56.873411,
      35.851368
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Вагжанова, 9",
    "coords": [
      56.853597,
      35.932647
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, б-р, Шмидта, 45",
    "coords": [
      56.871793,
      35.908465
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Сахаровское, 28",
    "coords": [
      56.864797,
      35.974536
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Красина, 46/48",
    "coords": [
      56.877705,
      35.907315
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Комсомольский, 1",
    "coords": [
      56.865968,
      35.911088
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Паши Савельевой, 84",
    "coords": [
      56.904743,
      35.821418
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, наб, Степана Разина, 23",
    "coords": [
      56.859429,
      35.924248
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Ленина, 5",
    "coords": [
      56.848517,
      35.828568
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Победы, 27",
    "coords": [
      56.84326,
      35.922128
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Желябова, 21",
    "coords": [
      56.855305,
      35.90727
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, 15 Лет Октября, 10",
    "coords": [
      56.844934,
      35.930285
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Фурманова, 12/4",
    "coords": [
      56.870716,
      35.898835
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, 50 Лет Октября, 38",
    "coords": [
      56.845357,
      35.798861
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Калинина, 19",
    "coords": [
      56.854719,
      35.86787
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Вокзальная, 9",
    "coords": [
      56.853306,
      35.937714
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Можайского, 71",
    "coords": [
      56.819331,
      35.904126
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Громова, 26",
    "coords": [
      56.844171,
      35.773924
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Фурманова, 72",
    "coords": [
      56.872418,
      35.888513
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Скворцова-Степанова, 83",
    "coords": [
      56.88256,
      35.893921
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Вагжанова, 19",
    "coords": [
      56.851289,
      35.937813
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Можайского, 72а",
    "coords": [
      56.813567,
      35.911869
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Петербургское, 45 Б",
    "coords": [
      56.872752,
      35.852473
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 99",
    "coords": [
      56.817454,
      35.887444
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Фрунзе, 5",
    "coords": [
      56.890309,
      35.839258
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, ПЕТЕРБУРГСКОЕ, 53А",
    "coords": [
      56.873721,
      35.843525
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Лизы Чайкиной, 17",
    "coords": [
      56.850457,
      35.833249
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Лизы Чайкиной, 17",
    "coords": [
      56.850457,
      35.833249
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Хромова, 25",
    "coords": [
      56.882815,
      35.854709
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Советская, 23",
    "coords": [
      56.859084,
      35.9184
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, п, Химинститута, 2",
    "coords": [
      56.800074,
      36.03148
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Хрустальная, 32/67",
    "coords": [
      56.889946,
      35.904431
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Громова, 3",
    "coords": [
      56.842787,
      35.769864
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Советская, 13",
    "coords": [
      56.859837,
      35.913019
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Можайского, 71",
    "coords": [
      56.819331,
      35.904126
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Октябрьский, 26",
    "coords": [
      56.829369,
      35.89711
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Горького, 86/3",
    "coords": [
      56.868162,
      35.899455
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, тер, Двор Пролетарки, 7",
    "coords": [
      56.851072,
      35.862902
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 71а",
    "coords": [
      56.824685,
      35.898206
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Можайского, 71",
    "coords": [
      56.819331,
      35.904126
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Коняевская, 14",
    "coords": [
      56.81606,
      35.985145
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Волоколамский, 2 к.1",
    "coords": [
      56.844161,
      35.91752
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Вагжанова, 21",
    "coords": [
      56.850471,
      35.939951
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, проезд, Швейников, 1",
    "coords": [
      56.844973,
      35.912247
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Паши Савельевой, 45",
    "coords": [
      56.89143,
      35.831281
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Дмитрия Донского, 37",
    "coords": [
      56.861348,
      35.88615
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Петербургское, 105",
    "coords": [
      56.875792,
      35.825478
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Паши Савельевой, 47",
    "coords": [
      56.898888,
      35.822487
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 105",
    "coords": [
      56.813532,
      35.883339
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Можайского, 71",
    "coords": [
      56.819331,
      35.904126
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Дружинная, 12",
    "coords": [
      56.827424,
      35.86248
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, п, Химинститута, 24",
    "coords": [
      56.802203,
      36.030636
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Ерофеева, 5",
    "coords": [
      56.845859,
      35.907827
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Ленина, 5",
    "coords": [
      56.848517,
      35.828568
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Горького, 21",
    "coords": [
      56.866558,
      35.909543
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Горького, 21",
    "coords": [
      56.866558,
      35.909543
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Волоколамский, 24",
    "coords": [
      56.836692,
      35.907845
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Спартака, 34 А",
    "coords": [
      56.850841,
      35.877778
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Пржевальского, 55",
    "coords": [
      56.862617,
      35.956947
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Трехсвятская, 6",
    "coords": [
      56.852755,
      35.909192
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Луначарского, 30 А",
    "coords": [
      56.881261,
      35.855734
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Паши Савельевой, 47",
    "coords": [
      56.898888,
      35.822487
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Кольцевая, 66",
    "coords": [
      56.88848,
      35.902428
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Чайковского, 7",
    "coords": [
      56.848857,
      35.905716
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Петербургское, 45Б",
    "coords": [
      56.872752,
      35.852473
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Вагжанова, 5",
    "coords": [
      56.854315,
      35.929898
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, п, Химинститута, 2",
    "coords": [
      56.800074,
      36.03148
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Чайковского, 35",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Калинина, 15 к.1",
    "coords": [
      56.85372,
      35.865292
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Маршала Конева, 12",
    "coords": [
      56.84867,
      35.840498
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Горького, 21",
    "coords": [
      56.866558,
      35.909543
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Калинина, 15 к.1",
    "coords": [
      56.85372,
      35.865292
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Калинина, 15 к.1",
    "coords": [
      56.85372,
      35.865292
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Трехсвятская, 8",
    "coords": [
      56.853252,
      35.909049
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Волоколамский, 24",
    "coords": [
      56.836692,
      35.907845
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Московское, 16",
    "coords": [
      56.844678,
      35.948269
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, наб, Афанасия Никитина, 92 Б",
    "coords": [
      56.867754,
      35.895008
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Волоколамский, 24",
    "coords": [
      56.836692,
      35.907845
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Горького, 21",
    "coords": [
      56.866558,
      35.909543
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 99",
    "coords": [
      56.817454,
      35.887444
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Кольцевая, 66",
    "coords": [
      56.88848,
      35.902428
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, б-р, Молодежный, 2",
    "coords": [
      56.883042,
      35.84039
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Калинина, 17",
    "coords": [
      56.854478,
      35.870915
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Новоторжская, 6",
    "coords": [
      56.858297,
      35.906731
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ш, Петербургское, 54/2",
    "coords": [
      56.874066,
      35.852491
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Вагжанова, 19",
    "coords": [
      56.851289,
      35.937813
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Вагжанова, 5",
    "coords": [
      56.854315,
      35.929898
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Ленина, 5",
    "coords": [
      56.848517,
      35.828568
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Волоколамский, 7 к.3",
    "coords": [
      56.846543,
      35.924006
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, ул, Можайского, 71",
    "coords": [
      56.819331,
      35.904126
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Калинина, 19",
    "coords": [
      56.854719,
      35.86787
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, б-р, Шмидта, 17",
    "coords": [
      56.873195,
      35.900137
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, наб, Реки Лазури, 9к1",
    "coords": [
      56.849413,
      35.930743
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, наб, Реки Лазури, 3",
    "coords": [
      56.850639,
      35.927006
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Бочкина, 15",
    "coords": [
      56.803519,
      35.98554
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ш, Московское, 18",
    "coords": [
      56.836298,
      35.946059
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, тер, Двор Пролетарки, 7",
    "coords": [
      56.851072,
      35.862902
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Калинина, 19",
    "coords": [
      56.854719,
      35.86787
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 28",
    "coords": [
      56.828847,
      35.895673
    ]
  },
  {
    "type": "ИПТ",
    "adress": "Тверь, пр-кт, Ленина, 30",
    "coords": [
      56.851397,
      35.843274
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 103",
    "coords": [
      56.814547,
      35.884785
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Калинина, 19",
    "coords": [
      56.854719,
      35.86787
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Калинина, 19",
    "coords": [
      56.854719,
      35.86787
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Луначарского, 30 А",
    "coords": [
      56.881261,
      35.855734
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Советская, 31",
    "coords": [
      56.858838,
      35.921032
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Луначарского, 30 А",
    "coords": [
      56.881261,
      35.855734
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Калинина, 19",
    "coords": [
      56.854719,
      35.86787
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, ул, Склизкова, 122",
    "coords": [
      56.829483,
      35.946463
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Тверь, пр-кт, Октябрьский, 105",
    "coords": [
      56.813532,
      35.883339
    ]
  },
  {
    "type": "Банкомат",
    "adress": "САДЫКОВО, , завод, 1",
    "coords": [
      53.323733,
      27.878963
    ]
  },
  {
    "type": "Банкомат",
    "adress": "РЯЗАНОВО, ул, Новая, 1",
    "coords": [
      55.490718,
      37.512469
    ]
  },
  {
    "type": "Банкомат",
    "adress": "Заволжский, , , 2",
    "coords": [
      56.890088,
      35.75788
    ]
  },
  {
    "type": "ИПТ",
    "adress": "САВВАТЬЕВО, , офисный центр, 1",
    "coords": [
      56.837455,
      36.104136
    ]
  },
  {
    "type": "Банкомат",
    "adress": "БУРАШЕВО, , строение, 1",
    "coords": [
      56.733689,
      35.875883
    ]
  }
]


export const refill_points = [
  {
    "type": "Тв003",
    "adress": "г. Тверь, ул. П. Савельевой, 35,к.2",
    "coords": [
      56.885048,
      35.838396
    ]
  },
  {
    "type": "Тв006",
    "adress": "г. Тверь, С.-Петербург. шоссе, 54",
    "coords": [
      60.102544,
      30.806501
    ]
  },
  {
    "type": "Тв004",
    "adress": "г. Тверь, С.-Петербург. шоссе,82/2",
    "coords": [
      60.102544,
      30.806501
    ]
  },
  {
    "type": "Тв007",
    "adress": "г. Тверь, ул. Горького, 135",
    "coords": [
      56.87013,
      35.881515
    ]
  },
  {
    "type": "Тв008",
    "adress": "г. Тверь, ул. Горького, 107",
    "coords": [
      56.869535,
      35.886474
    ]
  },
  {
    "type": "Тв009",
    "adress": "г. Тверь, ул. Горького, 53/4",
    "coords": [
      56.867523,
      35.901422
    ]
  },
  {
    "type": "Тв011",
    "adress": "г. Тверь, ул. Коноплянниковой, 2",
    "coords": [
      56.867769,
      35.906066
    ]
  },
  {
    "type": "Тв015",
    "adress": "г. Тверь, пр-кт Чайковского, 44",
    "coords": [
      56.843826,
      35.903138
    ]
  },
  {
    "type": "Тв014",
    "adress": "г. Тверь, ул. Трёхсвятская, 25",
    "coords": [
      56.855359,
      35.909399
    ]
  },
  {
    "type": "Тв012",
    "adress": "г. Тверь, Комсомольский пр-кт, 2/26",
    "coords": [
      56.865697,
      35.9123
    ]
  },
  {
    "type": "Тв023",
    "adress": "г. Тверь, Тверской пр-кт, 12",
    "coords": [
      56.859222,
      35.909129
    ]
  },
  {
    "type": "Тв027",
    "adress": "г. Тверь, Смоленский пер., 8",
    "coords": [
      56.852667,
      35.926395
    ]
  },
  {
    "type": "Тв035",
    "adress": "г. Тверь, пр-кт Ленина,8",
    "coords": [
      56.849123,
      35.827419
    ]
  },
  {
    "type": "Тв039",
    "adress": "г. Тверь, пр-кт Калинина, 4",
    "coords": [
      56.856107,
      35.878012
    ]
  },
  {
    "type": "Тв040",
    "adress": "г. Тверь, пр-кт Калинина, 13",
    "coords": [
      56.854876,
      35.869747
    ]
  },
  {
    "type": "Тв045",
    "adress": "г. Тверь, пр-кт Чайковского, 86",
    "coords": [
      56.839666,
      35.897613
    ]
  },
  {
    "type": "Тв043",
    "adress": "г. Тверь, пр-кт Победы, 2\"Б\"/24",
    "coords": [
      56.847725,
      35.907063
    ]
  },
  {
    "type": "Тв048",
    "adress": "г. Тверь, зал ожидания автовокзала",
    "coords": [
      56.859847,
      35.911995
    ]
  },
  {
    "type": "Тв049",
    "adress": "г. Тверь, Зелёный пр-зд, 41",
    "coords": [
      56.83029,
      35.922146
    ]
  },
  {
    "type": "Тв050",
    "adress": "г. Тверь, ул. Орджоникидзе, 4 (ТЦ)",
    "coords": [
      56.843673,
      35.937175
    ]
  },
  {
    "type": "Тв051",
    "adress": "г. Тверь, пр-кт Победы, 46/30",
    "coords": [
      56.839474,
      35.930195
    ]
  },
  {
    "type": "Тв054",
    "adress": "г. Тверь, пр-кт Победы, 22/15",
    "coords": [
      56.84392,
      35.918768
    ]
  },
  {
    "type": "Тв055",
    "adress": "г. Тверь, Волоколамский пр-кт, 24/43",
    "coords": [
      56.836692,
      35.907845
    ]
  },
  {
    "type": "Тв058",
    "adress": "г. Тверь, ул. Левитана, 81",
    "coords": [
      56.816828,
      35.906183
    ]
  },
  {
    "type": "Тв056",
    "adress": "г. Тверь, Октябрьский пр-кт, 65",
    "coords": [
      56.826409,
      35.896679
    ]
  },
  {
    "type": "Тв061",
    "adress": "г. Тверь, пр-кт Победы, 65",
    "coords": [
      56.835953,
      35.940274
    ]
  },
  {
    "type": "Тв101",
    "adress": "г. Тверь, б-р Гусева, у д. 18",
    "coords": [
      56.823518,
      35.902419
    ]
  },
  {
    "type": "Тв066",
    "adress": "г. Тверь, ул. Трёхсвятская, 2 (ТЦ)",
    "coords": [
      56.851751,
      35.908231
    ]
  },
  {
    "type": "Тв104",
    "adress": "г. Тверь, ул. Вагжанова, у д. 2а",
    "coords": [
      56.854448,
      35.927464
    ]
  },
  {
    "type": "Тв103",
    "adress": "г. Тверь, ул. Благоева, у д. 2а (ДК \"ВОГ\")",
    "coords": [
      56.869235,
      35.893993
    ]
  },
  {
    "type": "Тв105",
    "adress": "г. Тверь, пр.Тверской, у д. 3",
    "coords": [
      56.855073,
      35.907009
    ]
  },
  {
    "type": "Тв106",
    "adress": "г. Тверь, ул. В. Новгорода, у д. 3 (к/т \"Вулкан\")",
    "coords": [
      56.860511,
      35.912579
    ]
  },
  {
    "type": "Тв107",
    "adress": "г. Тверь, ул. Горького, у д. 124",
    "coords": [
      56.869318,
      35.892259
    ]
  },
  {
    "type": "Тв110",
    "adress": "г. Тверь, ул. Коминтерна, д. 18 (тоннель пешеходный)",
    "coords": [
      56.836131,
      35.893068
    ]
  },
  {
    "type": "Тв114",
    "adress": "г. Тверь, ул. Можайского, напротив д. 58",
    "coords": [
      56.819966,
      35.895834
    ]
  },
  {
    "type": "Тв119",
    "adress": "г. Тверь, ул. Горького, у д. 19 (Туполева)",
    "coords": [
      56.866076,
      35.913657
    ]
  },
  {
    "type": "Тв121",
    "adress": "г. Тверь, пр. Чайковского, у д. 35 (Спортивный)",
    "coords": [
      56.83907,
      35.895116
    ]
  },
  {
    "type": "Тв116",
    "adress": "г. Тверь, ул. Строителей, у д. 17 (рынок \"Первомайский\")",
    "coords": [
      56.841591,
      35.84216
    ]
  },
  {
    "type": "Тв124",
    "adress": "г. Тверь, б-р Шмидта, у д. 35",
    "coords": [
      56.872678,
      35.905159
    ]
  },
  {
    "type": "Тв125",
    "adress": "г. Тверь, ул. П. Савельевой, у д. 33",
    "coords": [
      56.890388,
      35.833348
    ]
  }
]